@if (countdownData(); as data) {
  <div class="countdown">
    <!-- days (optional) -->
    @if (data.days.enabled) {
      <app-countdown-section [config]="data.days" />
    }
    <!-- hours (optional) -->
    @if (data.hours.enabled) {
      <app-countdown-section [config]="data.hours" />
    }
    <!-- minutes (optional) -->
    @if (data.minutes.enabled) {
      <app-countdown-section [config]="data.minutes" />
    }
    <!-- seconds (always enabled) -->
    @if (data.seconds.enabled) {
      <app-countdown-section [config]="data.seconds" />
    }
  </div>
}
